module.exports = __webpack_public_path__ + "static/img/化工仪器网.259ef1b.png";


//////////////////
// WEBPACK FOOTER
// ./static/meiti-index/化工仪器网.png
// module id = RCJO
// module chunks = 1